import {
  takeLatest, put,
} from 'redux-saga/effects'
import request from '@/helpers/axios'
import { CREATE_GEOZONE } from '@/store/actions/installation'
import { INSTALLATIONS_GEOZONE_ENDPOINT } from '@/constants/apiRoutes'
import { successCreateGeoZone } from '@/store/actions/installation/createGeoZone'
import createNotifications from '@/helpers/notification'
import { GEOZONE, ROOT } from '@/constants/objectTypes'
import { requestGetRootElements } from '@/store/actions/installation/getRootElemenet'
import { setGlobalLoading, setTrueStatusGlobalFilter } from '@/store/actions/appSettings'
import { buildInstallationNodePath } from '@/helpers/installationTreeNode'
import { refreshInstallationTreeParent } from '@/store/sagas/installation/refreshInstallationTreeParent'
import { buildInstallationViewParams } from '@/helpers/installationViewParams'

function* createGeoZoneSaga({ payload }) {
  const {
    formValues, values, setUrlFormValues, maxRadiusValue, onComplete,
  } = payload
  const {
    city, lat, lon, mark, name, region, radius, maxRadius
  } = values
  const toast = createNotifications()
  try {
    const body = {
      parentId: formValues.id,
      name,
      city,
      region,
      point: {
        latitude: lat,
        longitude: lon,
      },
      note: mark,
      radius,
      maxRadius: maxRadius ? maxRadius : maxRadiusValue
    }
    yield put(setGlobalLoading(true))
    const { data } = yield request({
      url: INSTALLATIONS_GEOZONE_ENDPOINT,
      method: 'post',
      body,
    })
    const { rootId, path, FILTER } = formValues
    const geoZonePath = buildInstallationNodePath(path, data.id)

    const treeRefreshed = yield refreshInstallationTreeParent({
      parentId: data.parentId,
      nodeId: data.id,
      path,
    })

    if (!treeRefreshed || !rootId) {
      yield put(requestGetRootElements())
    }

    setUrlFormValues(buildInstallationViewParams({
      id: data.id,
      rootId,
      parentGeoZoneId: data.parentId,
      parentTreeId: data.parentId,
      ...(geoZonePath ? { path: geoZonePath } : {}),
      type: data.parentId ? GEOZONE : ROOT,
      FILTER,
    }))
    yield put(setGlobalLoading(false))
    toast({
      title: 'Создание геозоны',
      type: 'success',
      description: 'Геозона успешно создана.',
    })
    yield put(setTrueStatusGlobalFilter())

    if (onComplete) {
      onComplete()
    }

    yield put(successCreateGeoZone())
  } catch (error) {
    yield put(setGlobalLoading(false))
    toast({
      title: 'Создание геозоны',
      type: 'error',
      description: formValues.id ? 'Не удалось создать геозону, обратитесь к администратору.' : 'Не удалось создать корневую геозону, обратитесь к разработчикам платформы',
    })
    const { FILTER } = formValues
    setUrlFormValues({ FILTER })
    console.log('function*createGeoZoneSaga -> error', error)
  }
}

export default function* root() {
  yield takeLatest(CREATE_GEOZONE.REQUEST, createGeoZoneSaga)
}
